export function arrayChunk(arr, chunkSize) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }

    return res;
}

export function capitalizer(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
